import React from 'react';
import { motion } from 'framer-motion';
import './HearAtCon.css'; // Added for external CSS styling

const HearAtCon = () => {
  return (
    <div className='hear-at-con-container'>
      <div className='button-container'>
        <motion.button
          className='our-clients-button'
          whileHover={{
            boxShadow:
              '0 0 5px black, 0 0 10px black, 0 0 15px white, 0 0 20px black',
            transition: { duration: 0.5 },
          }}
          whileTap={{
            scale: 0.9,
            transition: { duration: 0.2 },
          }}
        >
          Our Clients
        </motion.button>
      </div>
      <div className='heading-container'>
        <h1 className='heading'>
          Hear it directly from <em style={{fontFamily: 'instrument-serif'}}>our clients</em>
        </h1>
      </div>
      <div className='description-container'>
        <p className='description'>
          Hear what our clients have to say. Our testimonials reflect the<br/>
          satisfaction our clients have in our services.
        </p>
      </div>
    </div>
  );
};

export default HearAtCon;
